import { Phone, Search, ArrowRight, Download } from "lucide-react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CLINIC, TRUST_PILLS, IMAGES } from "@/data/content";

export default function Hero() {
  return (
    <section id="acasa" className="relative pt-28 lg:pt-36 pb-16 lg:pb-24 overflow-hidden medical-grid">
      <div className="absolute top-0 right-0 w-[45%] h-full bg-gradient-to-bl from-[#EFE7D6]/60 to-transparent -z-10" />
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        {/* Left */}
        <div>
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
            className="inline-flex items-center gap-2 bg-[#EFE7D6] text-[#A6823B] text-xs font-semibold px-3.5 py-1.5 rounded-full mb-6">
            <span className="w-2 h-2 rounded-full bg-[#A6823B] animate-pulse" />
            Excelență medicală în Timișoara, din 2007
          </motion.div>

          <motion.h1 initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.1 }}
            data-testid="hero-title"
            className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900 leading-[1.1]">
            O experiență medicală de excepție,{" "}
            <span className="text-[#A6823B]">gândită în jurul tău</span>
          </motion.h1>

          <motion.p initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.2 }}
            className="mt-6 text-lg text-slate-600 leading-relaxed max-w-xl">
            Laborator propriu acreditat RENAR, peste 12 specialități și o echipă dedicată exclusiv confortului tău. Programează-te printr-un simplu telefon.
          </motion.p>

          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.3 }}
            className="mt-8 flex flex-col sm:flex-row gap-3">
            <a href={CLINIC.phoneRaw} data-testid="hero-phone-button"
              className="group inline-flex items-center justify-center gap-3 bg-[#A6823B] hover:bg-[#8A6B2E] text-white font-semibold text-lg px-7 py-4 rounded-full shadow-xl shadow-[#A6823B]/25 transition-all hover:-translate-y-0.5">
              <span className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center pulse-ring">
                <Phone className="w-4 h-4" />
              </span>
              Sună pentru programare
            </a>
            <Link to="/laborator"
              className="inline-flex items-center justify-center gap-2 bg-white border border-[#EADFC6] hover:border-[#A6823B] text-[#2A2521] font-semibold text-lg px-7 py-4 rounded-full transition-colors">
              Vezi analizele <ArrowRight className="w-4 h-4" />
            </Link>
            <a href={CLINIC.resultsUrl} target="_blank" rel="noopener noreferrer" data-testid="hero-results-button"
              className="inline-flex items-center justify-center gap-2 bg-[#2A2521] hover:bg-[#4a3a26] text-white font-semibold text-lg px-7 py-4 rounded-full transition-colors">
              <Download className="w-4 h-4" /> Rezultate online
            </a>
          </motion.div>

          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.7, delay: 0.5 }}
            className="mt-10 flex flex-wrap gap-x-6 gap-y-3">
            {TRUST_PILLS.map((p) => (
              <div key={p.label} className="flex items-center gap-2 text-sm text-slate-600 font-medium">
                <p.icon className="w-4 h-4 text-[#A6823B]" /> {p.label}
              </div>
            ))}
          </motion.div>
        </div>

        {/* Right */}
        <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.8, delay: 0.2 }}
          className="relative">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl shadow-[#A6823B]/20 aspect-[4/3] lg:aspect-[5/4] max-w-lg mx-auto lg:max-w-none">
            <img src={IMAGES.reception} alt="Recepția clinicii MEDAS Timișoara" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#2A2521]/20 to-transparent" />
          </div>
          {/* Floating card */}
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.7 }}
            className="absolute -bottom-5 -left-2 lg:-left-8 bg-white rounded-2xl shadow-xl border border-slate-100 p-4 flex items-center gap-3 max-w-[240px]">
            <span className="w-11 h-11 rounded-xl bg-[#A6823B]/10 flex items-center justify-center">
              <Search className="w-5 h-5 text-[#A6823B]" />
            </span>
            <div>
              <div className="font-display font-bold text-slate-900 text-sm">Rezultate în aceeași zi</div>
              <div className="text-xs text-slate-500">Discret, rapid, online</div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
